import {
  FormValue,
  Field,
  RadioboxGroup,
  SimpleCheckbox,
  SimpleRadiobox,
  ToggleCheckbox
} from '@startlibs/form'
import { SplitColumnsContainer } from '@startlibs/components'
import React, { useEffect } from 'react'
import { DIGITAL, OFFLINE } from '../../enums/PaymentMethod'
import { PriceInput } from '../../components/PriceInput'
import { TypeAutoComplete } from '../../components/TypeAutoComplete'

const ChargeValueInput = ({ description, defaultFees, form }) => {
  useEffect(() => {
    if (!description) return;
    const fee = defaultFees.find(f => f.description + ' (' + f.feeValue + ' USD)' === description);
    if (fee) {
      form.setValue('chargeValue', fee.feeValue);
    }
  }, [description]);

  return <PriceInput
    label="Out of pocket fee"
    path="chargeValue"
    placeholder="Ex: 300.00"
    mandatory
  />
}

export const PaymentDetailsForm = ({ defaultFees, canSendMailToContact, form }) => {

  const options = defaultFees.map(fee => fee.description + ' (' + fee.feeValue + ' USD)')

  return <>

    <SplitColumnsContainer>
      <TypeAutoComplete
        id="descriptionAutocomplete"
        path="description"
        hasErrors={form.hasErrors()}
        label="Fee description"
        placeholder="Ex: Additional consultation fee"
        mandatory
        initOptions={options}
        withDropdown
        tabIndex={1}
        multiline={true}
      />
      <FormValue path="description">
        {description => <ChargeValueInput description={description} defaultFees={defaultFees} form={form} />}
      </FormValue>
    </SplitColumnsContainer>
    <RadioboxGroup
      path="paymentMethod"
      label="Payment method"
      framedBoxes
      wide
      mandatory
      horizontal
    >
      <SimpleRadiobox label="Digital payment" fieldValue={DIGITAL} />
      <SimpleRadiobox label="Off-line payment" fieldValue={OFFLINE} />
    </RadioboxGroup>
    <FormValue
      path="paymentMethod"
    >{paymentMethod =>
      paymentMethod === DIGITAL
        ? canSendMailToContact
          ? <ToggleCheckbox
            path="sendEmail"
            label={<b>Send an email requesting payment when adding this fee</b>}
            css="margin-top:2rem"
            descText="You can also send the payment request by email later"
          />
          : null
        : paymentMethod === OFFLINE
          ? <Field label="Manual confirmation" css="margin-top: 1.5rem;">
            <SimpleCheckbox
              path="paid"
              label="Mark as paid"
              helpText="(in case paid externally already)"
              framedBoxes
              highlightSelected
            />
          </Field>
          : null
      }</FormValue>
  </>

}